import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./components/Header";
import Journal from "./components/Journal";
import Footer from "./components/Footer";
import House from "./pages/House";
import OurPeople from "./pages/OurPeople";
import Experiences from "./pages/Experiences";
import Legacy from "./pages/Legacy";
import Culinary from "./pages/Culinary";
import Contact from "./pages/Contact";
import Enquiries from "./pages/Enquiries";
import PressKit from "./pages/PressKit";
import Legal from "./pages/Legal";
import JournalArticle from "./pages/JournalArticle";
import ComingSoon from "./pages/ComingSoon";
import Threshold from "./components/Threshold";
import MobileCTA from "./components/MobileCTA";
import { SEO_MAP, REDIRECTS, SITE_URL } from "./seo";

const setHeadTag = (selector, create) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  return el;
};

const RouteSeo = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const meta =
      SEO_MAP[pathname] ||
      (pathname.startsWith("/journal") ? SEO_MAP["/journal"] : SEO_MAP["/"]);
    if (meta) {
      document.title = meta.title;
      const desc = setHeadTag('meta[name="description"]', () => {
        const m = document.createElement("meta");
        m.setAttribute("name", "description");
        return m;
      });
      desc.setAttribute("content", meta.desc);
    }
    const canonical = setHeadTag('link[rel="canonical"]', () => {
      const l = document.createElement("link");
      l.setAttribute("rel", "canonical");
      return l;
    });
    canonical.setAttribute("href", SITE_URL + pathname);
  }, [pathname]);
  return null;
};

const JournalPage = () => {
  return (
    <div id="top" className="min-h-screen flex flex-col bg-background-ivory">
      <Header />
      <Journal />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Threshold />
        <RouteSeo />
        <Routes>
          <Route path="/" element={<House />} />
          <Route path="/our-people" element={<OurPeople />} />
          <Route path="/journal" element={<JournalPage />} />
          <Route path="/journal/:slug" element={<JournalArticle />} />
          <Route path="/experiences" element={<Experiences />} />
          <Route path="/culinary" element={<Culinary />} />
          <Route path="/legacy" element={<Legacy />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/enquiries" element={<Enquiries />} />
          <Route path="/press-kit" element={<PressKit />} />
          <Route path="/legal" element={<Legal />} />
          {Object.entries(REDIRECTS).map(([from, to]) => (
            <Route key={from} path={from} element={<Navigate to={to} replace />} />
          ))}
          <Route
            path="*"
            element={<ComingSoon chapter="Lost Chapter" title="Not Found" />}
          />
        </Routes>
        <MobileCTA />
      </BrowserRouter>
    </div>
  );
}

export default App;
